import React from "react";
import { Line } from "react-chartjs-2";
import { chartHelpers } from "./Charts";
import dataLineChart from "./data/linechart.json";


export class MiniLineChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLineChart: chartHelpers.mergeColorsIntoData(this.props.data||dataLineChart)
    };
  }

  optionsLine() {
    return {
      legend:{display:false},
      tooltips:{interest:false,bodyFontSize:11,titleFontSize:11},
      scales:{
        xAxes:[
          {
              ticks:{
                  display:false
              },
              gridLines: {
                  display:false,
                  drawBorder:false
              }
          }
        ],
        yAxes:[{display:false}]
      },
      layout: {
        padding: {
          left: 6,
          right: 6,
          top: 4,
          bottom: 6
        }
      }
    };
  }

  render() {
    return (
      <Line
        data={chartHelpers.mergeColorsIntoData(this.state.dataLineChart)}
        options={this.optionsLine()}
      />
    );
  }
}

export default MiniLineChart;
